import React from 'react'
import { MdDeleteOutline } from "react-icons/md";


export default function Person({data, delFunc}) {

  console.log(data);
  console.log(data.PRESENCETHUR !== 'Non renseigné');

  return (
    data.NOM !== ' ' &&
      <div className='person'>
        <div className="info">
          <div className="nomPrenom">
            <h4>{data.NOM}</h4>
            <h4>{data.PRENOM}</h4>
          </div>
          <h4>{data.EMAIL}</h4>
          <h4>{data.TEL}</h4>
         
          {(data.WED === "Oui" && data.THUR === "Oui") ?
           <h4>Mercredi et jeudi</h4>

           : data.WED === "Oui" ?
             <h4>Mercredi</h4>
           : data.THUR === "Oui" &&
                <h4>Jeudi</h4>
          }
          {data.PRESENCEWED !== 'Non renseigné' &&
            <h4>Mercredi : {data.PRESENCEWED}</h4>
          }
          {(data.PRESENCETHUR !== 'Non renseigné') &&
            <h4>Jeudi : {data.PRESENCETHUR}</h4>
          }
       </div>
       <div className="delete">
          <MdDeleteOutline onClick={() => delFunc(data)} />
       </div>
      </div>
    
  )
}
